// 退款api
import { baseRequest, fileUploadRequest } from "./base";

/**
 * @desc 退款列表
 */
function getRefundList(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/finRefund/'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 退款
 */
function checkRefund(params) {
  return baseRequest(`/api/pcWeb/finRefund/checkRefund`, 'post', params);
}

/**
 * @desc 退款详情
 */
function get(id) {
  return baseRequest(`/api/pcWeb/finRefund/get/${id}`, 'get');
}

/**
 * @desc 导出退款单
 */
function exportRefund(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  return fileUploadRequest(`/api/pcWeb/finRefund/exportRefund`, params);
}




export default {
  getRefundList,
  checkRefund,
  get,
  exportRefund,
}

